<template>
  <inventory-item-adjustment-unit-select
    :inventory-item-adjustment="props.row"
  />
</template>

<script>

import InventoryItemAdjustmentUnitSelect from 'src/modules/admin/inventory-item/components/InventoryItemAdjustmentUnitSelect'

export default {
  name: 'InventoryItemAdjustmentUnitSelectEditorCell',
  components: {
    InventoryItemAdjustmentUnitSelect
  },
  props: {
    props: {
      type: Object,
      required: true
    }
  }
}

</script>
